<div
  *ngIf="currentStage <= maxStage"
  [ngClass]="'stage-' + currentStage"
  class="pre-login-container"
>
  <div class="stage-1">
    <img alt="" class="background" src="/img/pre-login-background.png">
    <object
      class="logo"
      data="/img/logo-text.svg"
      type="image/svg+xml"
    ></object>

    <div class="text">
      <span>{{ 'PreLogin.Stage1.Title' | translate | translateCut:0 }}</span>
      <br>
      <span>{{ 'PreLogin.Stage1.Title' | translate | translateCut:1 }}</span>
    </div>

    <button (click)="next()" class="next-button">
      <span>{{ 'PreLogin.Stage1.NextButton' | translate }}</span>
      <svg fill="none" height="11" viewBox="0 0 12 11" width="12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.57072 0.266321L0.545667 4.20754C0.196171 4.551 0 5.01561 0 5.4999C0 5.98418 0.196171 6.44879 0.545667 6.79225L4.57072 10.7335C4.74651 10.9042 4.98431 11 5.23218 11C5.48005 11 5.71785 10.9042 5.89364 10.7335C5.98158 10.6483 6.05138 10.5469 6.09901 10.4352C6.14664 10.3235 6.17117 10.2037 6.17117 10.0827C6.17117 9.96171 6.14664 9.84191 6.09901 9.73022C6.05138 9.61853 5.98158 9.51716 5.89364 9.43195L2.80683 6.41646L11.0618 6.41646C11.3106 6.41646 11.5492 6.31989 11.7252 6.148C11.9012 5.97611 12 5.74298 12 5.4999C12 5.25681 11.9012 5.02368 11.7252 4.85179C11.5492 4.6799 11.3106 4.58333 11.0618 4.58333L2.80683 4.58333L5.89364 1.56784C6.07031 1.39646 6.17006 1.16354 6.17094 0.92032C6.17182 0.677097 6.07376 0.443495 5.89833 0.270902C5.7229 0.0983102 5.48447 0.000865697 5.2355 5.4932e-06C4.98652 -0.000853756 4.74739 0.0949438 4.57072 0.266321Z"
          fill="#092473"/>
      </svg>
    </button>

  </div>
  <div class="stage-2">
    <img alt="" class="background" src="/img/pre-login-background.png">
    <object
      class="logo"
      data="/img/logo-text.svg"
      type="image/svg+xml"
    ></object>

    <div class="text header">
      <span [innerHTML]="'PreLogin.Stage2.Title' | translate">&nbsp;</span>
      <!--      <span class="red">?</span>-->
    </div>
    <div class="steps-container">
      <div class="step step-1">
        <div class="step-number">1</div>
        <!--        <div class="icon">-->
        <!--          <img src="/img/login-step-1.svg" alt="step 1"/>-->
        <!--        </div>-->

        <div [innerHTML]="'PreLogin.Stage2.Step1' | translate" class="text">
        </div>
      </div>

      <div class="step step-2">
        <div class="step-number">2</div>
        <!--        <div class="icon">-->
        <!--          <img src="/img/login-step-2.svg" alt="step 2"/>-->
        <!--        </div>-->

        <div [innerHTML]="'PreLogin.Stage2.Step2' | translate" class="text">
        </div>
      </div>

      <div class="step step-3">
        <div class="step-number">3</div>
        <!--        <div class="icon">-->
        <!--          <img src="/img/login-step-3.svg" alt="step 3"/>-->
        <!--        </div>-->

        <div [innerHTML]="'PreLogin.Stage2.Step3' | translate" class="text">
        </div>
      </div>
    </div>

    <button (click)="next()" class="next-button">
      <span>{{ 'PreLogin.Stage2.NextButton' | translate }}</span>
      <svg fill="none" height="11" viewBox="0 0 12 11" width="12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.57072 0.266321L0.545667 4.20754C0.196171 4.551 0 5.01561 0 5.4999C0 5.98418 0.196171 6.44879 0.545667 6.79225L4.57072 10.7335C4.74651 10.9042 4.98431 11 5.23218 11C5.48005 11 5.71785 10.9042 5.89364 10.7335C5.98158 10.6483 6.05138 10.5469 6.09901 10.4352C6.14664 10.3235 6.17117 10.2037 6.17117 10.0827C6.17117 9.96171 6.14664 9.84191 6.09901 9.73022C6.05138 9.61853 5.98158 9.51716 5.89364 9.43195L2.80683 6.41646L11.0618 6.41646C11.3106 6.41646 11.5492 6.31989 11.7252 6.148C11.9012 5.97611 12 5.74298 12 5.4999C12 5.25681 11.9012 5.02368 11.7252 4.85179C11.5492 4.6799 11.3106 4.58333 11.0618 4.58333L2.80683 4.58333L5.89364 1.56784C6.07031 1.39646 6.17006 1.16354 6.17094 0.92032C6.17182 0.677097 6.07376 0.443495 5.89833 0.270902C5.7229 0.0983102 5.48447 0.000865697 5.2355 5.4932e-06C4.98652 -0.000853756 4.74739 0.0949438 4.57072 0.266321Z"
          fill="#092473"/>
      </svg>
    </button>
  </div>
</div>
